import type { Dayjs } from 'dayjs';
import dashboardStyles from '@shared/components/Dashboard/Dashboard.module.scss';
import AntdSelect from '@shared/components/FormSelect/AntdSelect';
import { LocalizedRangePicker } from '@shared/components/LocalizedDatePicker';
import { PickerMode } from '@shared/common/types/main';
import { PICKER_MODE, PICKER_MODES } from '@shared/common/constants/PickerMode';

export interface DateRangeFilterProps {
  label?: string;
  value?: [Dayjs | null, Dayjs | null];
  defaultValue?: [Dayjs | null, Dayjs | null];
  onChange: (dates: [Dayjs | null, Dayjs | null] | null) => void;
  dateType?: PickerMode;
  onDateTypeChange?: (value: PickerMode) => void;
  showTypeSelector?: boolean;
  disabledDate?: (current: Dayjs) => boolean;
  allowEmpty?: [boolean, boolean];
  allowClear?: boolean;
  format?: string;
}

const DateRangeFilter = ({
  label = 'Range',
  value,
  defaultValue,
  onChange,
  dateType = PICKER_MODE.Date,
  onDateTypeChange,
  showTypeSelector = false,
  disabledDate,
  allowEmpty,
  allowClear = false,
  format,
}: DateRangeFilterProps) => (
  <div className={dashboardStyles.pill}>
    {label}
    {showTypeSelector && onDateTypeChange ? (
      <AntdSelect
        classes={dashboardStyles.rangeSelect}
        value={dateType}
        variant="borderless"
        options={[
          { value: PICKER_MODE.Date, label: 'Days' },
          { value: PICKER_MODE.Week, label: 'Week' },
          { value: PICKER_MODE.Month, label: 'Months' },
          { value: PICKER_MODE.Quarter, label: 'Quarter' },
          { value: PICKER_MODE.Year, label: 'Years' },
        ]}
        handleChange={(nextValue: string | string[]) => {
          if (!Array.isArray(nextValue) && PICKER_MODES.includes(nextValue as PickerMode)) {
            onDateTypeChange(nextValue as PickerMode);
          }
        }}
      />
    ) : null}
    <LocalizedRangePicker
      getPopupContainer={(trigger) => trigger.parentElement ?? document.body}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      size="small"
      variant="borderless"
      suffixIcon={undefined}
      allowEmpty={allowEmpty}
      allowClear={allowClear}
      disabledDate={disabledDate}
      picker={dateType}
      popupClassName={dashboardStyles.weekRange}
      format={format}
    />
  </div>
);

export default DateRangeFilter;
